import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';

    angular.module('app.admin.periodictasks').factory('PeriodicTasksSvc', PeriodicTasksSvc);

    PeriodicTasksSvc.$inject = ['logger', '$http', 'CONF', 'PeriodicTask'];

    /* @ngInject */
    function PeriodicTasksSvc(logger, $http, CONF, PeriodicTask) {
        var exports = {
            search: search,
            unlock: unlock,
            execute: execute
        };

        var baseUrl = CONF.apiContext + CONF.apiBaseUrl + '/v1/periodics';

        function search() {
            return $http.get(baseUrl).then(function(results) {
                return _.map(results.data, function(objData) {
                    return new PeriodicTask(objData);
                });
            });
        }

        function unlock(id) {
            var url = baseUrl + '/unlock/' + id;
            return $http.post(url);
        }

        function execute(id) {
            var url = baseUrl + '/execute/' + id;
            return $http.post(url);
        }

        return exports;
    }
})();
